import client from './apiConnector';

async function getApiKey() {
  return client().get('/apikey');
}
async function addDomain(params) {
  return client().post('/apikey/domain', params);
}
async function deleteDomain(id) {
  return client().delete('/apikey/domain', { data: [id] });
}

export default {
  getApiKey,
  deleteDomain,
  addDomain,
};
